import PropTypes from 'prop-types'

import React, { useState } from 'react'
import {
  Button
} from 'react-admin'
import IconContentAdd from '@material-ui/icons/Add'
import BulkDialog from './BulkDialog'

function BulkCloneButton ({ resource, resourceToRedirect, selectedIds }) {
  resourceToRedirect = resourceToRedirect === undefined ? resource : resourceToRedirect
  const [showDialog, setShowDialog] = useState(false)

  const handleOpen = () => {
    setShowDialog(true)
  }

  const handleClose = () => {
    setShowDialog(false)
  }

  return (
    <>
      <Button onClick={handleOpen} label="ra.action.clone">
        <IconContentAdd />
      </Button>
      <BulkDialog
        open={showDialog}
        handleClose={handleClose}
        resource={resource}
        resourceToRedirect={resourceToRedirect}
        selectedIds={selectedIds}
      />
    </>
  )
}

BulkCloneButton.propTypes = { resource: PropTypes.string, resourceToRedirect: PropTypes.string, selectedIds: PropTypes.arrayOf(PropTypes.number) }

export default BulkCloneButton
